import { createContext, useState, useEffect } from "react";

import API_BASE_URL from "../config/Api";

export const AuthContext = createContext();

const readStoredSession = () => {
    try {
        const savedUser = localStorage.getItem("userConnectedData");
        const token = localStorage.getItem("token");
        const user = savedUser ? JSON.parse(savedUser) : null;
        return token && (user?.Id || user?.id) ? { user, token } : { user: null, token: null };
    } catch (error) {
        return { user: null, token: null };
    }
};

export const AuthProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);

    const [{ user, token }, setSession] = useState(readStoredSession);
    const userId = user?.Id || user?.id;

    const login = (userData, tokenValue) => {
        localStorage.setItem("userConnectedData", JSON.stringify(userData));
        localStorage.setItem("token", tokenValue);
        setSession({ user: userData, token: tokenValue });
    };

    const logout = () => {
        setSession({ user: null, token: null });

        localStorage.removeItem("userConnectedData");
        localStorage.removeItem("token");
        localStorage.removeItem("company");
        localStorage.removeItem("dateStart");
        localStorage.removeItem("dateEnd");
        localStorage.removeItem("selectedModel");

        setLoading(false);
    };

    useEffect(() => {
        const syncSession = (event) => {
            if (event.type === "storage" && event.key && !["token", "userConnectedData"].includes(event.key)) return;
            setSession(readStoredSession());
        };
        window.addEventListener("storage", syncSession);
        window.addEventListener("soma-session-expired", syncSession);
        return () => {
            window.removeEventListener("storage", syncSession);
            window.removeEventListener("soma-session-expired", syncSession);
        };
    }, []);

    useEffect(() => {
        if (!token || !userId) {
            localStorage.removeItem("token");
            localStorage.removeItem("userConnectedData");
            setLoading(false);
            return undefined;
        }

        let active = true;
        setLoading(true);

        API_BASE_URL.get(`/users/${userId}`)
            .then((response) => {
                if (!active || localStorage.getItem("token") !== token || !response?.data) return;
                const responseUserId = response.data.id || response.data.Id;
                if (String(responseUserId) !== String(userId)) return;
                const savedSession = readStoredSession();
                if (savedSession.token !== token) return;

                const refreshedUser = {
                    ...savedSession.user,
                    Id: responseUserId,
                    email: response.data.email || savedSession.user.email,
                    permissions: Array.isArray(response.data.permissions) ? response.data.permissions : [],
                };

                setSession({ user: refreshedUser, token });
                localStorage.setItem("userConnectedData", JSON.stringify(refreshedUser));
            })
            .catch(() => {
                // Keep the saved session when the backend is temporarily unavailable.
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => {
            active = false;
        };
    }, [token, userId]);


    return (
        <AuthContext.Provider value={{ user, token, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );

};
